
<div :class="multipage === true ? 'multi-page':'single-page'">
  <page-content :breadcrumb="breadcrumb" :title="title" :logo="logo">
    <slot></slot>
  </page-content>
</div>
